export const layoutTokens = {
  headerHeight: '65px',
  tableOffset: '200px',
} as const;
